<template>
    <div class="row w-100">
        <div class="input-group p-0">
            <input class="form-control" v-model="search" v-on:keyup="sendSearch($event.target.value)" type="search" placeholder="Procurar" id="search">            
            <button class="btn btn-primary" type="button">
                <font-awesome-icon icon="search"></font-awesome-icon>
            </button>
        </div>
    </div>    
            
</template>

<script>
import { ref } from 'vue-demi';

export default {
    name:"SearchInput",
    emits:["search"],
    setup(props, { emit }) {

        const search = ref("");

        const createDebounce = () => {            
            let timeout = null;
            return function (fnc, delayMs) {
                clearTimeout(timeout);                
                timeout = setTimeout(() => {                    
                    fnc();
                }, delayMs || 500);
            };
        }

        const sendSearch = (currentValue) => {                 
            createDebounce()(() => {
                emit("search", currentValue);
            }, 500);            
            
        }               

        return {
            search,
            sendSearch
        }
    },        

}
</script>

